import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const stats = [
  { value: "10,000+", label: "Happy Customers" },
  { value: "5,000+", label: "Products Available" },
  { value: "24hrs", label: "Delivery Time" },
  { value: "100%", label: "Authentic Products" },
];

const offerings = [
  {
    icon: "fa-solid fa-pills",
    title: "Prescription Medicines",
    desc: "Genuine prescription drugs sourced directly from verified manufacturers.",
  },
  {
    icon: "fa-solid fa-flask",
    title: "Supplements & Vitamins",
    desc: "A full range of vitamins, minerals, and wellness boosters for every need.",
  },
  {
    icon: "fa-solid fa-heart",
    title: "Personal Care",
    desc: "Premium personal care and hygiene products for your daily routine.",
  },
  {
    icon: "fa-solid fa-truck",
    title: "Fast Doorstep Delivery",
    desc: "Safe, tracked, and fast delivery right to your home in 24 hours.",
  },
  {
    icon: "fa-solid fa-stethoscope",
    title: "Expert Guidance",
    desc: "Proper usage information and healthcare assistance from our team.",
  },
  {
    icon: "fa-solid fa-shield",
    title: "Secure Transactions",
    desc: "End-to-end encrypted payments with complete privacy protection.",
  },
];

const values = [
  { icon: "fa-solid fa-handshake", title: "Integrity", desc: "Honesty in every transaction and every product we offer." },
  { icon: "fa-solid fa-users", title: "Customer-Centric", desc: "Your health and satisfaction drive every decision we make." },
  { icon: "fa-solid fa-lightbulb", title: "Innovation", desc: "Continuously improving our platform for the best experience." },
  { icon: "fa-solid fa-circle-check", title: "Reliability", desc: "Consistent quality service you can trust, every single time." },
];

const About = () => {

  useEffect(() => {
    document.title = "About | dawaacare";
  }, [])

  return (
    <div>
      <Header />

      {/* ── Hero Banner ── */}
      <section className="about-hero-section" data-aos="zoom-in">
        <div className="about-hero-content">
          <div className="about-hero-text">
            <span className="about-eyebrow">Who Are We</span>
            <h1 className="hero-title about-hero-title">
              About <span className="big-span">Us</span>
            </h1>
            <p className="hero-subtitle about-hero-sub">
              Welcome to <strong>Dawaa Pharmacy</strong>, your trusted healthcare partner. We are dedicated to providing high-quality medicines, healthcare products, and professional guidance to ensure the well-being of our valued customers. At Dawaacare, we prioritize your health by offering genuine, affordable, and effective medications. Our experienced pharmacists are always available to provide expert advice, prescription assistance, and personalized healthcare solutions. Whether you need over-the-counter medicines, prescription drugs, or wellness products, we have you covered.
            </p>
            <Link to="/products" className="cta-button about-hero-cta">
              Shop Now &nbsp;<i className="fa-solid fa-arrow-right"></i>
            </Link>
          </div>

          <div className="hero-image-wrapper about-hero-image-wrapper">
            <div className="about-hero-badge-grid">
              {stats.map((s, i) => (
                <div className="about-stat-card" key={i}>
                  <span className="about-stat-value">{s.value}</span>
                  <span className="about-stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── Mission ── */}
      <section className="about-section about-mission" data-aos="fade-up">
        <span className="about-eyebrow" style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "24px" }}>
          <i className="fa-solid fa-bullseye"></i> Our Mission
        </span>
        <div className="about-mission-layout">
          <div className="about-mission-text">
            <h2>Delivering Healthcare <span className="about-red">You Can Trust</span></h2>
            <p>
              We are committed to maintaining customer satisfaction, transparency, and excellence in pharmaceutical care. Visit us today and experience reliable service, expert guidance, and a commitment to your health at Dawaa Pharmacy. Your health is our priority! With a strong focus on customer care, we strive to make healthcare accessible and affordable for everyone. Trust us for all your medical needs and let us be your partner in a healthier tomorrow!
            </p>
          </div>
          <div className="about-mission-accent">
            <div className="about-accent-circle">
              <i className="fa-solid fa-heart"></i>
            </div>
          </div>
        </div>
      </section>

      {/* ── What We Offer ── */}
      <section className="about-section about-offerings" data-aos="fade-up">
        <span className="about-eyebrow" style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "24px" }}>
          <i className="fa-solid fa-store"></i> What We Offer
        </span>
        <h2 className="about-section-title">Everything Your Health <span className="about-red">Needs</span></h2>
        <div className="about-offerings-grid">
          {offerings.map((item, i) => (
            <div className="about-offer-card" key={i}>
              <div className="about-offer-icon">
                <i className={item.icon}></i>
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Values ── */}
      <section className="about-section about-values" data-aos="fade-up">
        <span className="about-eyebrow" style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "24px" }}>
          <i className="fa-solid fa-star"></i> Our Values
        </span>
        <h2 className="about-section-title">What We <span className="about-red">Stand For</span></h2>
        <div className="about-values-grid">
          {values.map((v, i) => (
            <div className="about-value-card" key={i}>
              <i className={v.icon}></i>
              <div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA Strip ── */}
      <section className="about-cta-strip" data-aos="fade-up">
        <div className="about-cta-strip-inner">
          <div>
            <h2>Ready to take charge of your health?</h2>
            <p>Browse thousands of authentic products and get them delivered in 24 hours.</p>
          </div>
          <Link to="/products" className="about-cta-strip-btn">
            Order Now &nbsp;<i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
